// Dashboard Moderation translations (en-US), loaded into dashboard.moderation by ./en-US.js
module.exports = {
  label: "Moderation",
  health: require('./moderation/en-US.health.js'),
};
